import type { VlanRange } from '@/hooks/useDeviceActions';

/** True when every range is well-formed (1..=4094, start <= end) and the list is non-empty. */
export function vlanRangesValid(ranges: VlanRange[]): boolean {
  return (
    ranges.length > 0 &&
    ranges.every(
      (r) => Number.isInteger(r.start) && Number.isInteger(r.end) && r.start >= 1 && r.end <= 4094 && r.start <= r.end,
    )
  );
}
